// src/services/authService.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, axiosInstance } from 'lib';

const TRANSPORT_MODE = process.env.REACT_APP_TRANSPORT_MODE;
const OTP_API =
    TRANSPORT_MODE !== "production"
        ? API.VERIFY_OTP
        : API.VERIFY_OTP;

const FIRM_CREATE_ADMIN =
    TRANSPORT_MODE !== "production"
        ? API.CREATE_ADMIN
        : API.CREATE_ADMIN;

const FIRM_CREATE_COMPANY =
    TRANSPORT_MODE !== "production"
        ? API.CREATE_COMAPNY
        : API.CREATE_COMAPNY;

export const login = createAsyncThunk(
    '/user/send_otp',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.SEND_OTP, data);

            return response.data;
        } catch (err) {

            const message =
                err.response?.data?.responseMessage;
            return rejectWithValue(err.response?.data);
        }
    }
);

export const logout = createAsyncThunk('auth/logout', async (data = {}, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(API.LOGOUT, data);
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response.data);
    }
});


export const OtpVerify = createAsyncThunk(
    'Send verify',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(OTP_API, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const account = createAsyncThunk(
    'add account',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(FIRM_CREATE_ADMIN, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const addCompany = createAsyncThunk(
    'add Company',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(FIRM_CREATE_COMPANY, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);


export const ImageUploadAvtar = createAsyncThunk(
    'image Upload',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.UPLOAD_PROFILE_IMAGE, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const allCitiesApi = createAsyncThunk(
    'All Cities',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.ALL_CITIES_API, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const allStateApi = createAsyncThunk(
    'All State',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.ALL_STATE_API, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const createRouteApi = createAsyncThunk(
    'Create Route',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.CREATE_ROUTE, data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);


export const companyImageUpload = createAsyncThunk(
    'image Company Upload',
    async (data = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(API.COMPANY_PROFILE_UPLOAD, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const superAdminLoginApi = (data = {}) => {
    return axiosInstance
        .post(API.SUPER_ADMIN_LOGIN, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            ;
        });
};




